import styled, { css } from 'styled-components';

// COLORS
import { theme } from '../../constants/theme';

//Interf
import { IBreadCrumbProps } from '../../interfaces/BreadCrumb.interface';

const BreadCrumbWrapper = styled.section`
  height: 3vh;
  padding: ${(props: IBreadCrumbProps) => props.padding};
  display: flex;
  align-items: center;
  font-size: 12px;

  ${(props: IBreadCrumbProps) =>
    props.isWhite &&
    css`
      a {
        color: ${theme.colors.primary.white};
        white-space: nowrap;
      }
      svg {
        fill: ${theme.colors.primary.white};

        path {
          fill: ${theme.colors.primary.white};
        }
      }
      p {
        color: ${theme.colors.primary.white};
        padding: 0 1vw 0 1vw;
      }
    `}

  ${(props: IBreadCrumbProps) =>
    !props.isWhite &&
    css`
      a {
        color: ${theme.colors.secondary.gray400};
        white-space: nowrap;
      }
      svg {
        fill: ${theme.colors.secondary.gray400};

        path {
          fill: ${theme.colors.secondary.gray400};
        }
      }
      p {
        color: ${theme.colors.secondary.gray400};
        padding: 0 1vw 0 1vw;
      }
    `}    

  a {
    text-decoration: none;
    cursor: pointer;
  }

  ${(props: IBreadCrumbProps) =>
    !props.activeIsBlack &&
    css`
      a:last-child {
        color: ${theme.colors.primary.bariBlue};
      }
    `}

  ${(props: IBreadCrumbProps) =>
    props.activeIsBlack &&
    css`
      a:last-child {
        color: ${theme.colors.primary.black};
      }
    `}  

  svg {
    margin-right: 10px;
  }
`;

export default BreadCrumbWrapper;
